import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { l, Popover } from '@manychat/manyui'

import { ClosePopover } from 'components/MuiPopover'

import MaterialColors from './MaterialColors'

import cm from './ColorPicker.module.css'

class ColorPalette extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false
  }

  render() {
    const { onClick, withClearColor = false } = this.props
    return (
      <div className={cm.palette}>
        {Object.keys(MaterialColors).map((paletteName, i) => {
          const palette = MaterialColors[paletteName]
          return (
            <div key={i} className={cm.colorGroup}>
              {Object.keys(palette)
                .filter((c) => c[0] !== 'a')
                .map((cName, j) => {
                  if (withClearColor && i === 0 && j === 0) {
                    return (
                      <div key={j} className={cm.colorGroupItem}>
                        <div onClick={onClick} data-hex={''} className={cm.clearColor}>
                          <div />
                        </div>
                      </div>
                    )
                  }
                  return (
                    <div key={j} className={cm.colorGroupItem}>
                      <div
                        onClick={onClick}
                        data-hex={palette[cName]}
                        style={{ backgroundColor: palette[cName] }}
                      />
                    </div>
                  )
                })}
            </div>
          )
        })}
      </div>
    )
  }
}

class ColorPicker extends Component {
  static propTypes = {
    disableTooltip: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    closeAfterSelect: PropTypes.bool,
    size: PropTypes.number,
    noHover: PropTypes.bool,
    withClearColor: PropTypes.bool,
    onOpenChange: PropTypes.func,
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      open: false,
      anchorEl: null,
    }
  }

  handleChange = (value) => {
    const { name, onChange } = this.props
    onChange(name, value)
  }

  handleInputChange = (e) => {
    let v = e.target.value
    v = ('#' + v.replace(/(?![abcdefABCDEF0-9]).{1}/g, '')).slice(0, 7).toUpperCase()

    this.handleChange(v)
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleInputBlur()
      this.handleRequestClose()
    }
  }

  handleInputBlur = (e) => {
    const { value } = this.props
    if (value === '#') {
      this.handleChange('')
    }
  }

  handlePaletteClick = (e) => {
    const value = e.currentTarget.dataset.hex.toUpperCase()
    this.handleChange(value.toUpperCase())

    this.setState({ open: !this.props.closeAfterSelect })
  }

  handleOpen = (e) => {
    this.setState({ open: true, anchorEl: e.currentTarget })
  }
  handleRequestClose = () => this.setState({ open: false })

  componentDidUpdate(prevProps, prevState) {
    if (prevState.open !== this.state.open && this.props.onOpenChange) {
      this.props.onOpenChange(this.state.open)
    }
  }

  componentWillUnmount() {
    if (this.props.onOpenChange) {
      this.props.onOpenChange(false)
    }
  }

  render() {
    const { open } = this.state
    const {
      label,
      value,
      disableTooltip,
      disabled,
      className = '',
      style = {},
      size = 28,
      noHover = false,
      withClearColor = false,
    } = this.props

    const getColorIcon = () => {
      return (
        <svg viewBox="0 0 200 200" style={{ fill: value || '#FFFFFF' }}>
          <circle cx="100" cy="100" r="95" strokeWidth="10"></circle>
          {!value && withClearColor && (
            <line
              x1="0"
              y1="100"
              x2="200"
              y2="100"
              transform="rotate(45 100 100)"
              strokeWidth="15"
              stroke="#EB5038"
            />
          )}
        </svg>
      )
    }

    return (
      <a
        className={cx(cm.wrapper, !noHover && 'bg-hover', className)}
        onClick={disabled ? () => {} : this.handleOpen}
        style={style}
      >
        <div className={cm.color} style={{ width: `${size}px`, height: `${size}px` }}>
          {getColorIcon()}
          {!open && !disableTooltip && value && <div className={cm.tooltip}>{value}</div>}
        </div>
        {label && <span className="m-l-xs">{l.getString(label)}</span>}
        <Popover
          open={this.state.open}
          anchor={this.state.anchorEl}
          anchorOrigin={'left top'}
          popoverOrigin={'left top'}
          onRequestClose={this.handleRequestClose}
        >
          <div className={cm.picker}>
            <ClosePopover onClick={this.handleRequestClose} />
            <div className={cm.pickerHeader}>
              <span>{label}</span>
            </div>
            <div className={cm.current}>
              {getColorIcon()}

              <input
                type="text"
                value={value}
                onChange={this.handleInputChange}
                onBlur={this.handleInputBlur}
                onKeyPress={this.handleKeyPress}
              />

              <div className={cx(cm.help, 'm-l-xs')}>
                {l.translate('Use hex color code or pick from palette')}
              </div>
            </div>
            <ColorPalette onClick={this.handlePaletteClick} withClearColor={withClearColor} />
          </div>
        </Popover>
      </a>
    )
  }
}

export default ColorPicker
